import {
    apiRequest,
    verCheck,
    verVerification,
    openVerification,
    verListTunkin,
    verListHonorarium,
    verListUangMakan,
    verListPltPlh,
    exportExcelTunkin,
    exportExcelTunkinTxt,
    exportExcelHonorarium,
    exportExcelHonorariumTxt,
    exportExcelUangMakan,
    exportExcelUangMakanTxt,
    exportExcelPltPlh,
    exportExcelPltPlhTxt,
    syncPresensi,
    verCheckGenerate,
    verSetGenerate,
    checkGenerateStatus,
    fetchExportMatching,
    fetchVerifikasiMatching
} from "../../../../../services/adapters/kepegawaian/verificationPresensiService"

class IndexRepository {

    fetchCheck = async (query) => {
        return await apiRequest("get", verCheck, {
            params: query
        }, true)
    }
    fetchGenerate = async (query) => {
        return await apiRequest("get", verCheckGenerate, {
            params: query
        }, true)
    }
    setGenerate = async (query) => {
        return await apiRequest("get", verSetGenerate, {
            params: query
        }, true)
    }
    
    fetchVerification = async (query) => {
        return await apiRequest("post", verVerification, {
            body: query
        }, true)
    }
    openVerification = async (query) => {
        return await apiRequest("post", openVerification, {
            body: query
        }, true)
    }

    fetchListTunkin = async (query) => {
        return await apiRequest("get", verListTunkin, {
            params: query
        }, true)
    }

    fetchListHonorarium = async (query) => {
        return await apiRequest("get", verListHonorarium, {
            params: query
        }, true)
    }

    fetchListUangMakan = async (query) => {
        return await apiRequest("get", verListUangMakan, {
            params: query
        }, true)
    }

    fetchListPltPlh = async (query) => {
        return await apiRequest("get", verListPltPlh, {
            params: query
        }, true)
    }
    fetchExportTunkin = async (query) => {
        return await apiRequest("get", exportExcelTunkin, {
            params: query
        }, true)
    }
    fetchExportTunkinTxt = async (query) => {
        return await apiRequest("get", exportExcelTunkinTxt, {
            params: query
        }, true)
    }

    fetchExportHonorarium = async (query) => {
        return await apiRequest("get", exportExcelHonorarium, {
            params: query
        }, true)
    }
    fetchExportHonorariumTxt = async (query) => {
        return await apiRequest("get", exportExcelHonorariumTxt, {
            params: query
        }, true)
    }
    fetchExportUangMakan = async (query) => {
        return await apiRequest("get", exportExcelUangMakan, {
            params: query
        }, true)
    }

    fetchExportUangMakanTxt = async (query) => {
        return await apiRequest("get", exportExcelUangMakanTxt, {
            params: query
        }, true)
    }

    fetchExportPltPlh = async (query) => {
        return await apiRequest("get", exportExcelPltPlh, {
            params: query
        }, true)
    }

    fetchExportPltPlhTxt = async (query) => {
        return await apiRequest("get", exportExcelPltPlhTxt, {
            params: query
        }, true)
    }

    fetchSync = async (query) => {
        return await apiRequest("get", syncPresensi, {
            params: query
        }, true)
    }
    fetchcheckStatusGenerateChannel = async (query) => {
        return await apiRequest("get", checkGenerateStatus, {
            params: query
        }, true)
    }

    fetchExportMatching = async (query) => {
        return await apiRequest("get", fetchExportMatching, {
            params: query
        }, true)
    }


    fetchVerifikasiMatching = async (query) => {
        return await apiRequest("post", fetchVerifikasiMatching, {
            body: query
        }, true)
    }
}

export default IndexRepository